module.exports = __webpack_public_path__ + "img/68.b87116ec.jpg";